import { Avatar } from "@mui/material";
import { AdminPageLayout, AdminSectionCard } from "../../components/admin/AdminPageLayout";
import { getAdminProfile } from "../../utils/auth";

function getInitials(name) {
  if (!name?.trim()) return "?";
  return name
    .trim()
    .split(/\s+/)
    .slice(0, 2)
    .map((part) => part[0])
    .join("")
    .toUpperCase();
}

function ProfileField({ label, value }) {
  return (
    <div className="account-field">
      <span className="account-field__label">{label}</span>
      <span className="account-field__value">{value || "—"}</span>
    </div>
  );
}

export default function AccountPage() {
  const profile = getAdminProfile();

  if (!profile) {
    return (
      <AdminPageLayout
        eyebrow="Account"
        title="My Account"
        description="Sign in to view your profile."
      />
    );
  }

  return (
    <AdminPageLayout
      eyebrow="Account"
      title="My Account"
      description="View your admin panel profile and account details."
    >
      <AdminSectionCard title="Profile">
        <div className="account-profile">
          <Avatar className="account-profile__avatar" aria-hidden="true">
            {getInitials(profile.fullName)}
          </Avatar>
          <div className="account-profile__summary">
            <h2 className="account-profile__name">{profile.fullName}</h2>
            <span className="account-profile__role">{profile.role}</span>
          </div>
        </div>

        <div className="account-fields">
          <ProfileField label="Full name" value={profile.fullName} />
          <ProfileField label="Username" value={profile.username} />
          <ProfileField label="Email" value={profile.email} />
          <ProfileField label="Role" value={profile.role} />
          <ProfileField label="Status" value={profile.status} />
        </div>
      </AdminSectionCard>
    </AdminPageLayout>
  );
}
